module.exports = __webpack_public_path__ + "static/media/ic_placeholder.f1d48116.png";